import { syncNavMegamenuNavbarHeight, syncMobileMegamenuFooterContent } from './navMegamenuHelpers.js';
import scrollService, { getScrollInstance } from '../core/ScrollService.js';
const initNavMegamenu = () => {
    const root = document.getElementById('nav-megamenu');
    if (!root) return;

    const backdrop = root.querySelector('.nav-megamenu__backdrop');
    const mainLinks = root.querySelectorAll('.mainNav a[data-menu]');
    const megamenus = root.querySelector('.nav-megamenu__megamenus');
    const megamenuPanels = root.querySelectorAll('.nav-megamenu__megamenu');
    const closeBtns = root.querySelectorAll('.nav-megamenu__close-btn');
    const burger = root.querySelector('.navbar_mobileToggle');
    const mobilePanel = root.querySelector('.nav-megamenu__mobile');
    const drawerSectionBack = root.querySelector('.navbar_drawerSectionBack');
    const drawerSectionBackLabel = root.querySelector('.navbar_drawerSectionBack-label');

    const setMobileDrawerSectionLabel = (text) => {
        if (drawerSectionBackLabel) drawerSectionBackLabel.textContent = text || '';
    };

    const syncMobileDrawerChrome = () => {
        const open = root.classList.contains('nav-megamenu--mobile-open');
        const cur = root.querySelector('.nav-megamenu__mobile-level--current');
        const sub = open && cur && cur.getAttribute('data-level') !== '1';
        root.classList.toggle('nav-megamenu--mobile-submenu', !!sub);
        if (!open) {
            if (drawerSectionBack) drawerSectionBack.setAttribute('hidden', '');
            setMobileDrawerSectionLabel('');
            return;
        }
        if (!sub) {
            if (drawerSectionBack) drawerSectionBack.setAttribute('hidden', '');
        } else if (drawerSectionBack) {
            drawerSectionBack.removeAttribute('hidden');
        }
    };

    const mobileLevels = root.querySelectorAll('.nav-megamenu__mobile-level');
    const mobileLinksSub = root.querySelectorAll('.nav-megamenu__mobile-link--sub');
    const mobileLvlCur = 'nav-megamenu__mobile-level--current';
    const mobileLvlOffR = 'nav-megamenu__mobile-level--off-right';
    const mobileLvlOffL = 'nav-megamenu__mobile-level--off-left';

    const resetMobileLevels = () => {
        mobileLevels.forEach((level) => {
            const lv = level.getAttribute('data-level');
            level.classList.remove(mobileLvlOffL, mobileLvlOffR, mobileLvlCur);
            if (lv === '1') {
                level.classList.add(mobileLvlCur);
                level.setAttribute('aria-hidden', 'false');
            } else {
                level.classList.add(mobileLvlOffR);
                level.setAttribute('aria-hidden', 'true');
            }
        });
    };

    const showMobileLevelForward = (levelEl) => {
        if (!levelEl) return;
        const current = root.querySelector(`.${mobileLvlCur}`);
        if (current === levelEl) return;
        if (current) {
            current.classList.remove(mobileLvlCur);
            current.classList.add(mobileLvlOffL);
            current.setAttribute('aria-hidden', 'true');
        }
        levelEl.classList.remove(mobileLvlOffR, mobileLvlOffL);
        levelEl.classList.add(mobileLvlCur);
        levelEl.setAttribute('aria-hidden', 'false');
        const level = levelEl.getAttribute('data-level');
        mobilePanel.classList.toggle('is-level-1', level === '1');
        syncMobileMegamenuFooterContent({ root, currentLevelClass: mobileLvlCur });
    };

    const showMobileLevelBack = (parentEl) => {
        if (!parentEl) return;
        const current = root.querySelector(`.${mobileLvlCur}`);
        if (current) {
            current.classList.remove(mobileLvlCur);
            current.classList.add(mobileLvlOffR);
            current.setAttribute('aria-hidden', 'true');
        }
        parentEl.classList.remove(mobileLvlOffL, mobileLvlOffR);
        parentEl.classList.add(mobileLvlCur);
        parentEl.setAttribute('aria-hidden', 'false');
        const level = parentEl.getAttribute('data-level');
        mobilePanel.classList.toggle('is-level-1', level === '1');
        syncMobileMegamenuFooterContent({ root, currentLevelClass: mobileLvlCur });
    };

    const getMenuLabel = (menuId) => (menuId ? menuId.charAt(0).toUpperCase() + menuId.slice(1) : '');

    const accordionTriggers = root.querySelectorAll('.nav-megamenu__accordion-trigger');

    /** Desktop méga-menu : Locomotive Scroll capte la molette → pause pour scroller uniquement dans le sous-menu */
    let locomotivePausedForMegamenu = false;
    const isDesktopMegamenuViewport = () => window.matchMedia('(min-width: 931px)').matches;
    const pauseLocomotiveForMegamenu = () => {
        if (!isDesktopMegamenuViewport() || !getScrollInstance()) return;
        try {
            scrollService.stop();
            locomotivePausedForMegamenu = true;
        } catch (err) { /* noop */ }
    };
    const resumeLocomotiveAfterMegamenu = () => {
        if (!locomotivePausedForMegamenu || !getScrollInstance()) return;
        try {
            scrollService.start();
        } catch (err) { /* noop */ }
        locomotivePausedForMegamenu = false;
    };

    const openMegamenu = (menuId) => {
        root.classList.remove('is-megamenu-closing');
        const prevVisible = root.querySelector('.nav-megamenu__megamenu.is-visible');
        if (prevVisible) {
            prevVisible.classList.remove('is-visible');
        }
        megamenuPanels.forEach((panel) => {
            const id = panel.getAttribute('data-menu');
            if (id === menuId) {
                panel.classList.remove('is-closing');
                panel.removeAttribute('hidden');
                panel.setAttribute('aria-hidden', 'false');
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        panel.classList.add('is-visible');
                    });
                });
            } else {
                panel.classList.remove('is-visible', 'is-closing');
                panel.setAttribute('hidden', '');
                panel.setAttribute('aria-hidden', 'true');
            }
        });
        root.classList.add('is-megamenu-open');
        
        document.querySelector('.searchBar').classList.remove('open');
        document.querySelector('.navSearch').classList.remove('open');

        mainLinks.forEach((link) => {
            const id = link.getAttribute('data-menu');
            link.classList.toggle('current', id === menuId);
            link.setAttribute('aria-expanded', id === menuId ? 'true' : 'false');
        });
        pauseLocomotiveForMegamenu();
    };

    const closeMegamenu = () => {
        const visiblePanel = root.querySelector('.nav-megamenu__megamenu.is-visible');
        if (!visiblePanel) {
            root.classList.remove('is-megamenu-open', 'is-megamenu-closing');
            megamenuPanels.forEach((panel) => {
                panel.setAttribute('hidden', '');
                panel.setAttribute('aria-hidden', 'true');
                panel.classList.remove('is-visible', 'is-closing');
            });
            mainLinks.forEach((link) => {
                link.classList.remove('current');
                link.setAttribute('aria-expanded', 'false');
            });
            resumeLocomotiveAfterMegamenu();
            return;
        }
        root.classList.add('is-megamenu-closing');
        visiblePanel.classList.remove('is-visible');
        visiblePanel.classList.add('is-closing');
        let megamenuCloseDone = false;
        const finishClose = () => {
            if (megamenuCloseDone) {
                return;
            }
            megamenuCloseDone = true;
            visiblePanel.removeEventListener('transitionend', onTransitionEnd);
            root.classList.remove('is-megamenu-open', 'is-megamenu-closing');
            visiblePanel.classList.remove('is-closing');
            visiblePanel.setAttribute('hidden', '');
            visiblePanel.setAttribute('aria-hidden', 'true');
            megamenuPanels.forEach((p) => {
                p.classList.remove('is-visible');
            });
            mainLinks.forEach((link) => {
                link.classList.remove('current');
                link.setAttribute('aria-expanded', 'false');
            });
            resumeLocomotiveAfterMegamenu();
        };
        const onTransitionEnd = (e) => {
            if (e.target !== visiblePanel || e.propertyName !== 'transform') {
                return;
            }
            finishClose();
        };
        visiblePanel.addEventListener('transitionend', onTransitionEnd);
        // Fallback : durée max fermeture (transform SCSS ~0.75s)
        setTimeout(() => {
            if (visiblePanel.classList.contains('is-closing')) {
                finishClose();
            }
        }, 900);
    };

    /** Réinitialise N2 + L3/L4 du méga-menu Produits ouvert (plusieurs rubriques type produits dans le DOM). */
    let resetProduitsMegamenuToFirst = null;

    mainLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const menuId = link.getAttribute('data-menu');
            const isOpen = root.classList.contains('is-megamenu-open') && link.classList.contains('current');
            if (isOpen) {
                closeMegamenu();
            } else {
                openMegamenu(menuId);
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        if (typeof resetProduitsMegamenuToFirst !== 'function') {
                            return;
                        }
                        const esc =
                            typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
                                ? CSS.escape(menuId)
                                : String(menuId).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
                        const produitsMm = root.querySelector(
                            `.nav-megamenu__megamenu--produits[data-menu="${esc}"]`
                        );
                        if (produitsMm) {
                            resetProduitsMegamenuToFirst(produitsMm);
                        }
                    });
                });
            }
        });
    });

    backdrop.addEventListener('click', closeMegamenu);
    closeBtns.forEach((btn) => btn.addEventListener('click', closeMegamenu));

    const produitsMegamenus = root.querySelectorAll('.nav-megamenu__megamenu--produits');
    if (produitsMegamenus.length) {
        const resetL3L4Panel = (panel) => {
            if (!panel || !panel.classList.contains('nav-megamenu__produits-panel--has-l3l4')) return;
            const sectionLinks = panel.querySelectorAll('.nav-megamenu__sections-link[data-detail-id]');
            const detailBlocks = panel.querySelectorAll('.nav-megamenu__detail-block[data-detail-id]');
            const firstLink = panel.querySelector('.nav-megamenu__sections-link[data-detail-id]');
            const targetId = firstLink ? firstLink.getAttribute('data-detail-id') : null;
            sectionLinks.forEach((l) => {
                const on = targetId !== null && l.getAttribute('data-detail-id') === targetId;
                l.classList.toggle('is-active', on);
                if (l.getAttribute('role') === 'tab') {
                    l.setAttribute('aria-selected', on ? 'true' : 'false');
                }
            });
            detailBlocks.forEach((b) => {
                const on = targetId !== null && b.getAttribute('data-detail-id') === targetId;
                b.classList.toggle('is-active', on);
            });
        };

        const updateProduitsPush = (visiblePanel, megamenuRoot) => {
            if (!visiblePanel || !megamenuRoot) return;
            const cardImg = megamenuRoot.querySelector('.nav-megamenu__card-img-el');
            const cardTitleEl = megamenuRoot.querySelector('.nav-megamenu__card-title');
            const cardLinkEl = megamenuRoot.querySelector('.nav-megamenu__card-link');
            const src = visiblePanel.getAttribute('data-card-img');
            if (src && cardImg) cardImg.setAttribute('src', src);
            const title = visiblePanel.getAttribute('data-card-title');
            const linkText = visiblePanel.getAttribute('data-card-link');
            const href = visiblePanel.getAttribute('data-card-href') || '#';
            if (title && cardTitleEl) cardTitleEl.textContent = title;
            if (linkText && cardLinkEl) {
                cardLinkEl.textContent = linkText;
                cardLinkEl.setAttribute('href', href);
            }
        };

        // Même effet bulle que `.button` (initButtons) : fond rgb(39,50,63), texte → blanc (voir _navbar-megamenu.scss)
        root.querySelectorAll('.nav-megamenu__produit').forEach((button) => {
            if (button.querySelector('.button_circle')) return;
            button.innerHTML = '<span>' + button.innerHTML + '</span>';
            const domBubble = document.createElement('div');
            domBubble.classList.add('button_circle_bubble');
            const domCircle = document.createElement('div');
            domCircle.appendChild(domBubble);
            domCircle.classList.add('button_circle');
            button.appendChild(domCircle);
            const circle = button.querySelector('.button_circle');
            const bubble = button.querySelector('.button_circle_bubble');
            if (!circle || !bubble) return;
            let buttonBounds = button.getBoundingClientRect();
            button.addEventListener('mouseenter', (e) => {
                buttonBounds = button.getBoundingClientRect();
                const posX = e.clientX - buttonBounds.left;
                const posY = e.clientY - buttonBounds.top;
                circle.style.transform = 'translate(' + posX + 'px,' + posY + 'px)';
                bubble.style.transform = 'scale(1)';
                bubble.style.opacity = '1';
            });
            button.addEventListener('mouseleave', () => {
                bubble.style.transform = 'scale(0)';
                bubble.style.opacity = '0';
            });
        });

        produitsMegamenus.forEach((produitsMegamenu) => {
            const produitsList = produitsMegamenu.querySelector('.nav-megamenu__produits-list');
            const panels = produitsMegamenu.querySelectorAll('.nav-megamenu__produits-panel');
            const productBtns = produitsMegamenu.querySelectorAll('.nav-megamenu__produit');
            if (!produitsList || !panels.length) {
                return;
            }

            produitsMegamenu.querySelectorAll('.nav-megamenu__produits-panel--has-l3l4').forEach((panel) => {
                const sectionLinks = panel.querySelectorAll('.nav-megamenu__sections-link[data-detail-id]');
                const detailBlocks = panel.querySelectorAll('.nav-megamenu__detail-block[data-detail-id]');
                sectionLinks.forEach((link) => {
                    link.addEventListener('click', (e) => {
                        e.preventDefault();
                        const id = link.getAttribute('data-detail-id');
                        sectionLinks.forEach((l) => {
                            const on = l.getAttribute('data-detail-id') === id;
                            l.classList.toggle('is-active', on);
                            l.setAttribute('aria-selected', on ? 'true' : 'false');
                        });
                        detailBlocks.forEach((block) => {
                            const on = block.getAttribute('data-detail-id') === id;
                            block.classList.toggle('is-active', on);
                        });
                    });
                });
            });

            const initialBtn =
                produitsList.querySelector('.nav-megamenu__produit.is-active') || productBtns[0];
            const initialKey = initialBtn ? initialBtn.getAttribute('data-produit') : null;
            panels.forEach((p) => {
                const panelKey = p.getAttribute('data-panel');
                const on = panelKey === initialKey;
                p.classList.toggle('is-active', on);
            });
            const firstVis =
                produitsMegamenu.querySelector('.nav-megamenu__produits-panel.is-active') || panels[0];
            if (firstVis) {
                updateProduitsPush(firstVis, produitsMegamenu);
                if (firstVis.classList.contains('nav-megamenu__produits-panel--has-l3l4')) {
                    resetL3L4Panel(firstVis);
                }
            }

            productBtns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    const key = btn.getAttribute('data-produit');
                    productBtns.forEach((b) => b.classList.toggle('is-active', b === btn));
                    let visiblePanel = null;
                    panels.forEach((p) => {
                        const panelKey = p.getAttribute('data-panel');
                        const on = panelKey === key;
                        p.classList.toggle('is-active', on);
                        if (on) visiblePanel = p;
                    });
                    updateProduitsPush(visiblePanel, produitsMegamenu);
                    if (visiblePanel && visiblePanel.classList.contains('nav-megamenu__produits-panel--has-l3l4')) {
                        resetL3L4Panel(visiblePanel);
                    }
                });
            });
        });

        resetProduitsMegamenuToFirst = function (megamenuEl) {
            const productBtns = megamenuEl.querySelectorAll('.nav-megamenu__produit');
            const panels = megamenuEl.querySelectorAll('.nav-megamenu__produits-panel');
            if (!productBtns.length || !panels.length) {
                return;
            }
            const firstBtn = productBtns[0];
            const key = firstBtn.getAttribute('data-produit');
            productBtns.forEach((b) => b.classList.toggle('is-active', b === firstBtn));
            let visiblePanel = null;
            panels.forEach((p) => {
                const on = p.getAttribute('data-panel') === key;
                p.classList.toggle('is-active', on);
                if (on) visiblePanel = p;
            });
            updateProduitsPush(visiblePanel, megamenuEl);
            if (visiblePanel && visiblePanel.classList.contains('nav-megamenu__produits-panel--has-l3l4')) {
                resetL3L4Panel(visiblePanel);
            }
        };
    }

    const mobileOpen = () => {
        if (!burger || !mobilePanel) return;
        root.classList.add('nav-megamenu--mobile-open');
        burger.classList.add('opened');
        burger.setAttribute('aria-expanded', 'true');
        mobilePanel.removeAttribute('hidden');
        mobilePanel.classList.remove('nav-megamenu__mobile--open');
        mobilePanel.setAttribute('aria-hidden', 'true');
        resetMobileLevels();
        mobilePanel.classList.add('is-level-1');
        setMobileDrawerSectionLabel('');
        syncMobileDrawerChrome();
        syncMobileMegamenuFooterContent({ root, currentLevelClass: mobileLvlCur });
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                mobilePanel.classList.add('nav-megamenu__mobile--open');
                mobilePanel.setAttribute('aria-hidden', 'false');
            });
        });

        document.querySelector('.searchBar').classList.remove('open');
        document.querySelector('.navSearch').classList.remove('open');
    };

    const mobileCloseFn = () => {
        if (!mobilePanel) return;
        root.classList.remove('nav-megamenu--mobile-open', 'nav-megamenu--mobile-submenu');
        mobilePanel.classList.remove('nav-megamenu__mobile--open');
        mobilePanel.setAttribute('aria-hidden', 'true');
        mobilePanel.setAttribute('hidden', '');
        if (burger) {
            burger.classList.remove('opened');
            burger.setAttribute('aria-expanded', 'false');
        }
        mobilePanel.classList.remove('is-level-1');
        if (drawerSectionBack) drawerSectionBack.setAttribute('hidden', '');
        setMobileDrawerSectionLabel('');
    };

    if (burger && mobilePanel) {
        burger.addEventListener('click', () => {
            if (mobilePanel.getAttribute('aria-hidden') === 'true' || mobilePanel.hasAttribute('hidden')) {
                mobileOpen();
            } else {
                mobileCloseFn();
            }
        });

        if (drawerSectionBack) {
            drawerSectionBack.addEventListener('click', () => {
                const currentLevel = root.querySelector(`.${mobileLvlCur}`);
                if (!currentLevel) return;
                const level = parseInt(currentLevel.getAttribute('data-level'), 10);
                const parent = currentLevel.getAttribute('data-parent');
                if (level === 2 && parent) {
                    const level1 = root.querySelector('.nav-megamenu__mobile-level[data-level="1"]');
                    showMobileLevelBack(level1);
                    setMobileDrawerSectionLabel('');
                    syncMobileDrawerChrome();
                } else if (level === 3) {
                    const rootMenu = currentLevel.getAttribute('data-mm-root') || (parent && parent.indexOf('-') !== -1 ? parent.replace(/-[^-]+$/, '') : parent);
                    const level2El = rootMenu && root.querySelector(`.nav-megamenu__mobile-level[data-level="2"][data-parent="${rootMenu}"]`);
                    if (level2El) {
                        showMobileLevelBack(level2El);
                        setMobileDrawerSectionLabel(getMenuLabel(rootMenu));
                        syncMobileDrawerChrome();
                    }
                }
            });
        }

        mobileLinksSub.forEach((link) => {
            link.addEventListener('click', (e) => {
                const menu = link.getAttribute('data-menu');
                const sub = link.getAttribute('data-sub');
                if (menu) {
                    e.preventDefault();
                    const level2 = root.querySelector(`.nav-megamenu__mobile-level[data-level="2"][data-parent="${menu}"]`);
                    if (level2) {
                        showMobileLevelForward(level2);
                        const ml = link.getAttribute('data-menu-label');
                        setMobileDrawerSectionLabel(ml || getMenuLabel(menu));
                        syncMobileDrawerChrome();
                    }
                }
                if (sub) {
                    e.preventDefault();
                    const level3 = root.querySelector(`.nav-megamenu__mobile-level[data-level="3"][data-parent="${sub}"]`);
                    if (level3) {
                        showMobileLevelForward(level3);
                        const sl = link.getAttribute('data-sub-label');
                        const parentKey = sub.replace(/^([^-]+)-.*/, '$1');
                        setMobileDrawerSectionLabel(sl || getMenuLabel(parentKey));
                        syncMobileDrawerChrome();
                    }
                }
            });
        });
    }

    accordionTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            const expanded = trigger.getAttribute('aria-expanded') === 'true';
            const panelId = trigger.getAttribute('aria-controls');
            const panel = panelId ? document.getElementById(panelId) : trigger.nextElementSibling;
            trigger.setAttribute('aria-expanded', !expanded);
            if (panel) {
                if (expanded) {
                    panel.setAttribute('hidden', '');
                } else {
                    panel.removeAttribute('hidden');
                }
            }
        });
    });

    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (root.classList.contains('is-megamenu-open')) {
            closeMegamenu();
        }
        if (mobilePanel && mobilePanel.getAttribute('aria-hidden') === 'false' && !mobilePanel.hasAttribute('hidden')) {
            mobileCloseFn();
        }
    });

    syncNavMegamenuNavbarHeight();
    if (typeof window.__silaeNavMegamenuResizeRef === 'function') {
        window.removeEventListener('resize', window.__silaeNavMegamenuResizeRef);
    }
    window.__silaeNavMegamenuResizeRef = syncNavMegamenuNavbarHeight;
    window.addEventListener('resize', window.__silaeNavMegamenuResizeRef);
    if (window.__silaeNavMegamenuResizeObserver) {
        window.__silaeNavMegamenuResizeObserver.disconnect();
        window.__silaeNavMegamenuResizeObserver = null;
    }
    const navBarEl = root.querySelector('.navbar');
    if (navBarEl && typeof ResizeObserver !== 'undefined') {
        window.__silaeNavMegamenuResizeObserver = new ResizeObserver(() => syncNavMegamenuNavbarHeight());
        window.__silaeNavMegamenuResizeObserver.observe(navBarEl);
    }
    requestAnimationFrame(() => requestAnimationFrame(syncNavMegamenuNavbarHeight));
};

export class NavMegamenu {
    init() {
        initNavMegamenu();
    }
}

export { initNavMegamenu };
